<template>
  <div>
    <div class="vs-row">
      <vs-col vs-lg="12" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Default</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <vs-alert active="true">
              Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat
            </vs-alert>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="12" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Title</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <vs-alert title="Lorem ipsum dolor sit amet" active="true">
              Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat
            </vs-alert>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="12" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Color</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <vs-alert
              class="mb-3"
              color="primary"
              title="Primary"
              active="true"
            >
              Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
            </vs-alert>
            <vs-alert
              class="mb-3"
              title="Success"
              active="true"
              color="success"
            >
              Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat
            </vs-alert>
            <vs-alert class="mb-3" title="Danger" active="true" color="danger">
              Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
              reprehenderit in voluptate velit esse cillum dolore eu fugiat
              nulla pariatur. Excepteur sint occaecat cupidatat non proident,
              sunt in culpa qui officia deserunt mollit anim id est laborum.
            </vs-alert>
            <vs-alert class="mb-3" title="Danger" active="true" color="warning">
              Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </vs-alert>
            <vs-alert class="mb-3" title="Dark" active="true" color="dark">
              Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat
            </vs-alert>
            <vs-alert
              class="mb-3"
              title="RGB"
              active="true"
              color="rgb(41, 147, 138)"
            >
              Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat
            </vs-alert>
            <vs-alert title="HEX" active="true" color="#842993">
              Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat
            </vs-alert>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="12" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Closable</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <vs-alert
              :active.sync="active1"
              closable
              class="mb-3"
              close-icon="close"
            >
              Lorem ip sum dolor sit amet, consectetur adipisicing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat
            </vs-alert>

            <vs-alert :active.sync="active1" closable close-icon="cancel">
              Lorem ip sum dolor sit amet, consectetur adipisicing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat
            </vs-alert>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="12" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Icons</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <vs-alert active="true" color="rgb(111, 38, 224)" :icon="icon1" >
     Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat
   </vs-alert>
          </div>
        </div>
      </vs-col>
    </div>
  </div>
</template>
<script>
export default {
  watch: {
    "$store.state.theme"(val) {
      this.chartTheme(val);
    },
  },
  methods: {
    chartTheme(val) {
      let mode = val == "dark" ? "dark" : "light";
      return mode;
    },
  },
  mounted() {
    this.chartTheme(this.$store.state.theme);
  },
  data: () => ({ active1: true,   icon1: 'sms',}),
};
</script>